// import axios from 'axios';
import api from '@/api';
import * as types from './mutation-types';

export default {
    fetchPressList({ commit }) {
        console.log('ENV', process.env.VUE_APP_API_BASE_URL); 
        return api.get('/MediaNews').then((res) => {
            console.log('res', res);
            commit(types.FETCH_PRESSLIST, res.data.data);
        });
    },
}; 